export default __webpack_public_path__ + "static/media/google-sheets-logo.dd8591c2.svg";